





























import { Prop, Component, Vue } from "vue-property-decorator";
import TaskGroupForm from "@/viewmodels/task-group-form";
import OperatorSelect from "../OperatorSelect.vue";
import TaskTypeSelect from "../TaskTypeSelect.vue";
import VendorSelect from "../VendorSelect.vue";

@Component({
  components: { TaskTypeSelect, VendorSelect, OperatorSelect }
})
export default class VTaskGroupControl extends Vue {
  @Prop({ required: true }) projectId!: number;
  @Prop({ required: true }) taskGroup!: TaskGroupForm;

  resetOfficeAndStaff() {
    this.taskGroup.officeId = "";
    this.taskGroup.staffId = "";
  }

  resetStaff() {
    this.taskGroup.staffId = "";
  }
}
